import * as React from "react";


import DrawerList from "../../admin seller/components/drawerList/DrawerList";
import DashboardIcon from '@mui/icons-material/Dashboard';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import AddIcon from '@mui/icons-material/Add';
import HomeIcon from '@mui/icons-material/Home';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import { Category } from "@mui/icons-material";
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import LogoutIcon from '@mui/icons-material/Logout';
import CampaignIcon from '@mui/icons-material/Campaign';
const menu = [
    {
        name: "Dashboard",
        path: "/admin",
        icon: <DashboardIcon className="text-primary-color" />,
        activeIcon: <DashboardIcon className="text-white" />,
    },
    {
        name: "Coupons",
        path: "/admin/coupon",
        icon: <IntegrationInstructionsIcon className="text-primary-color" />,
        activeIcon: <IntegrationInstructionsIcon className="text-white" />,
    },
    {
        name: "Add New Coupon",
        path: "/admin/add-coupon",
        icon: <AddIcon className="text-primary-color" />,
        activeIcon: <AddIcon className="text-white" />,
    },
    {
        name: "Home Page",
        path: "/admin/home-grid",
        icon: <HomeIcon className="text-primary-color" />,
        activeIcon: <HomeIcon className="text-white" />,
    },
    {
        name: "Electronics Category",
        path: "/admin/electronics-category",
        icon: <ElectricBoltIcon className="text-primary-color" />,
        activeIcon: <ElectricBoltIcon className="text-white" />,
    },
    {
        name: "Shop By Category",
        path: "/admin/shop-by-category",
        icon: <Category className="text-primary-color" />,
        activeIcon: <Category className="text-white" />,
    },
    {
        name: "Deals",
        path: "/admin/deals",
        icon: <LocalOfferIcon className="text-primary-color" />,
        activeIcon: <LocalOfferIcon className="text-white" />,
    },
    {
    name: "Notification Bar",
    path: "/admin/notification-bar",
    icon: <CampaignIcon className="text-primary-color" />,
    activeIcon: <CampaignIcon className="text-white" />,
    },
   
];

const menu2 = [

    {
        name: "Account",
        path: "/seller/account",
        icon: <AccountBoxIcon className="text-primary-color" />,
        activeIcon: <AccountBoxIcon className="text-white" />,
    },
    {
        name: "Logout",
        path: "/",
        icon: <LogoutIcon className="text-primary-color" />,
        activeIcon: <LogoutIcon className="text-white" />,
    },

]

interface DrawerListProps{
    toggleDrawer?:any;
}

const AdminDrawerList = ({ toggleDrawer }: DrawerListProps) => {

    return (
        <>
            <DrawerList toggleDrawer={toggleDrawer} menu={menu} menu2={menu2}/>
        </>
    );
}; 

export default AdminDrawerList;


// import * as React from "react";
// import { useLocation, useNavigate } from "react-router-dom";

// import DashboardIcon from "@mui/icons-material/Dashboard";
// import LocalOfferIcon from "@mui/icons-material/LocalOffer";
// import AddIcon from "@mui/icons-material/Add";
// import HomeIcon from "@mui/icons-material/Home";
// import ElectricBoltIcon from "@mui/icons-material/ElectricBolt";
// import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
// import { Category } from "@mui/icons-material";
// import AccountBoxIcon from "@mui/icons-material/AccountBox";
// import LogoutIcon from "@mui/icons-material/Logout";
// import CampaignIcon from "@mui/icons-material/Campaign";
// import MenuIcon from "@mui/icons-material/Menu";
// import { IconButton, Tooltip } from "@mui/material";

// const menu = [
//   {
//     name: "Dashboard",
//     path: "/admin",
//     icon: <DashboardIcon />,
//   },
//   {
//     name: "Coupons",
//     path: "/admin/coupon",
//     icon: <IntegrationInstructionsIcon />,
//   },
//   {
//     name: "Add New Coupon",
//     path: "/admin/add-coupon",
//     icon: <AddIcon />,
//   },
//   {
//     name: "Home Page",
//     path: "/admin/home-grid",
//     icon: <HomeIcon />,
//   },
//   {
//     name: "Electronics Category",
//     path: "/admin/electronics-category",
//     icon: <ElectricBoltIcon />,
//   },
//   {
//     name: "Shop By Category",
//     path: "/admin/shop-by-category",
//     icon: <Category />,
//   },
//   {
//     name: "Deals",
//     path: "/admin/deals",
//     icon: <LocalOfferIcon />,
//   },
//   {
//     name: "Notification Bar",
//     path: "/admin/notification-bar",
//     icon: <CampaignIcon />,
//   },
// ];

// const menu2 = [
//   {
//     name: "Account",
//     path: "/seller/account",
//     icon: <AccountBoxIcon />,
//   },
//   {
//     name: "Logout",
//     path: "/",
//     icon: <LogoutIcon />,
//   },
// ];

// interface DrawerListProps {
//   toggleDrawer?: any;
// }

// const AdminDrawerList = ({ toggleDrawer }: DrawerListProps) => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [collapsed, setCollapsed] = React.useState(false);

//   const closeDrawerIfMobile = () => {
//     if (toggleDrawer) {
//       try {
//         toggleDrawer(false);
//       } catch {
//         toggleDrawer();
//       }
//     }
//   };

//   const handleNavigate = (path: string) => {
//     navigate(path);
//     closeDrawerIfMobile();
//   };

//   const isActive = (path: string) => {
//     if (path === "/admin") {
//       return location.pathname === "/admin";
//     }

//     return location.pathname.startsWith(path);
//   };

//   const renderMenuItem = (item: any) => {
//     const active = isActive(item.path);

//     const content = (
//       <button
//         key={item.name}
//         onClick={() => handleNavigate(item.path)}
//         className={`w-full flex items-center gap-6 px-6 py-4 rounded-r-full transition-all duration-300 ${
//           active
//             ? "bg-primary-color text-white"
//             : "text-primary-color hover:bg-teal-50"
//         } ${collapsed ? "justify-center px-3" : ""}`}
//       >
//         <span className="flex items-center justify-center text-[1.7rem]">
//           {React.cloneElement(item.icon, {
//             className: active ? "text-white" : "text-primary-color",
//           })}
//         </span>

//         {!collapsed && (
//           <span className="text-lg font-medium whitespace-nowrap">
//             {item.name}
//           </span>
//         )}
//       </button>
//     );

//     return collapsed ? (
//       <Tooltip key={item.name} title={item.name} placement="right">
//         {content}
//       </Tooltip>
//     ) : (
//       content
//     );
//   };

//   return (
//     <div
//       className={`h-full bg-white border-r border-gray-200 transition-all duration-300 flex flex-col ${
//         collapsed ? "w-[90px]" : "w-[330px]"
//       }`}
//     >
//       <div
//         className={`flex items-center py-5 px-4 ${
//           collapsed ? "justify-center" : "justify-start"
//         }`}
//       >
//         <IconButton onClick={() => setCollapsed((prev) => !prev)}>
//           <MenuIcon className="text-primary-color" />
//         </IconButton>
//       </div>

//       <div className="flex-1 space-y-4 pr-4">
//         {menu.map(renderMenuItem)}
//       </div>

//       <div className="border-t border-gray-200 py-6 space-y-4 pr-4">
//         {menu2.map(renderMenuItem)}
//       </div>
//     </div>
//   );
// };

// export default AdminDrawerList;